const EMAIL_PATTERN = /[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+/g

/**
 * Replaces anything email-shaped with a placeholder.
 *
 * Server error text is safe today, but these payloads are about a guest's email address, so nothing
 * derived from them should reach an error report without passing through here first. See ENG-2910.
 */
export default function redactEmails(text: string): string {
  return text.replace(EMAIL_PATTERN, '[email]')
}
